<template>
    <div class="row">
    <div class="col-sm-2" id="main-column-left">
        <div class="header">
        <img class="logo" src="/img/logo-gdsn-publisher-dark-small.png" />
        </div>
        <div class="content">
        <div id="menu">
            <ul class="nav nav-pills flex-column">
            <li class="nav-item">
              <router-link
                :to="{ name: 'upload' }"
                class="nav-link"
                active-class="active"
                >
                <icon v-bind:is="this.icons" :icon="'upload'" /> Upload</a>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'dashboard' }"
                class="nav-link"
                active-class="active"
                >
                <icon v-bind:is="this.icons" :icon="'iconProducts'" /> Your DAM</a>
              </router-link>
            </li>
            </ul>
        </div>
        </div>
        <div class="footer">
        Powered by
        <br/>
        <img class="logo" src="/img/logo-trusted-source-dark.png" />
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="col-sm-10" id="main-column-right">
        <div class="header">
        <icon v-bind:is="this.icons" :icon="this.icon" />
        {{ this.title }}
        </div>
        <div class="content">
        <component v-bind:is="this.comp" />
        </div>
        <div class="footer"></div>
    </div>
    </div>
</template>

<script>
import TSHeader from "@/components/HeaderMain";
import TSFooter from "@/components/FooterMain";
import Assets from "@/views/Assets";
import Upload from "@/views/Upload";
import SyncHistory from "@/views/SyncHistory"
import icon from "@/assets/icons/icons";
require("@/assets/main.css");
require("@/assets/responsive.css");

export default {
  name: "DashboardBase",
  components: {
    TSHeader,
    TSFooter,
    icon
  },
  props: {
    title: { type: String, required: true },
    icon: { type: String, required: true },
    comp: { type: String, required: true }
  },
  data: function() {
    return {
      icons: icon
    }
  },
  components: {
      Assets,
      Upload,
      SyncHistory
  }
};
</script>
